import {
  MainTable5SActionTypes,
  MainTableData,
  LoadTableRequestAction,
  LoadTableSuccessAction,
  LoadTableFailureAction,
  LoadEditCardRequestAction,
  LoadEditCardSuccessAction,
  LoadEditCardFailureAction,
  ClearEditCardAction,
  DeleteCardRequestAction,
  DeleteCardSuccessAction,
  DeleteCardFailureAction,
} from '../../types/mainTable5S';

export const loadMainTable = (params: Record<string, any>): LoadTableRequestAction => ({
  type: MainTable5SActionTypes.LOAD_TABLE_REQUEST,
  payload: { params },
});

export const loadMainTableSuccess = (data: MainTableData): LoadTableSuccessAction => ({
  type: MainTable5SActionTypes.LOAD_TABLE_SUCCESS,
  payload: { data },
});

export const loadMainTableFailure = (error: string): LoadTableFailureAction => ({
  type: MainTable5SActionTypes.LOAD_TABLE_FAILURE,
  payload: { error },
});

export const loadEditCard = (id: number): LoadEditCardRequestAction => ({
  type: MainTable5SActionTypes.LOAD_EDIT_CARD_REQUEST,
  payload: { id },
});

export const loadEditCardSuccess = (data: any): LoadEditCardSuccessAction => ({
  type: MainTable5SActionTypes.LOAD_EDIT_CARD_SUCCESS,
  payload: { data },
});

export const loadEditCardFailure = (error: string): LoadEditCardFailureAction => ({
  type: MainTable5SActionTypes.LOAD_EDIT_CARD_FAILURE,
  payload: { error },
});

export const clearEditCard = (): ClearEditCardAction => ({
  type: MainTable5SActionTypes.CLEAR_EDIT_CARD,
});

export const deleteCard = (id: number): DeleteCardRequestAction => ({
  type: MainTable5SActionTypes.DELETE_CARD_REQUEST,
  payload: { id },
});

export const deleteCardSuccess = (id: number): DeleteCardSuccessAction => ({
  type: MainTable5SActionTypes.DELETE_CARD_SUCCESS,
  payload: { id },
});

export const deleteCardFailure = (error: string): DeleteCardFailureAction => ({
  type: MainTable5SActionTypes.DELETE_CARD_FAILURE,
  payload: { error },
});
